import React, { useState, useRef } from 'react';
import { Icon } from '@iconify/react'; 

const PopoverIcon = ({ content }) => {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef(null);

  const handleMouseEnter = () => {
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    setIsOpen(false);
  };

  return (
    <div 
      style={{ position: 'relative', display: 'inline-block' }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Icon icon="ph:info" className="text-xl ms-1 popover-trigger text-blue-700 font-bold" />
      {isOpen && (
        <div 
          className="popover-content" 
          ref={popoverRef} 
          style={{
            position: 'absolute',
            top: '100%',  // Positioning the popover below the icon
            left: '50%',
            transform: 'translateX(-50%)',  // Center the popover horizontally
            zIndex: 9999,  // Ensure the popover is on top of everything
            backgroundColor: '#fff',  // Background color for the popover
            padding: '10px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',  // Add shadow for a raised effect
            borderRadius: '4px',
            whiteSpace: 'nowrap',  // Prevent the content from wrapping
          }}
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default PopoverIcon;
